/* eslint-disable react/hook-use-state, max-statements */
import { useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations } from "@bluframe/mightychroma-mightytool-graphql-schema";
import axios from "axios";
import { useEffect, useState } from "react";
import HomeVideoReview from "./HomeVideoReview";
const { homeVideoReviews: { ADD_HOME_VIDEO_REVIEW } } = mutations;
const handleChangeId = (setId) => (ev) => {
    ev.preventDefault();
    setId(ev.currentTarget.value);
};
const HOSTNAME = "http://localhost";
const PORT = 3001;
const handleClear = ({ setAvForumsId, setAvNirvanaId, setAvsForumId, setBluRayAuthorityId, setBluRayId, setDigitalBitsId, setHidefDigestId, setHighDefDiscNewsId, setHomeTheaterForumId, setId, setIMDbId, setName, setTheaterByteId, setWhySoBluId }) => (ev) => {
    ev.preventDefault();
    setAvForumsId("");
    setAvNirvanaId("");
    setAvsForumId("");
    setBluRayAuthorityId("");
    setBluRayId("");
    setDigitalBitsId("");
    setHidefDigestId("");
    setHighDefDiscNewsId("");
    setHomeTheaterForumId("");
    setTheaterByteId("");
    setWhySoBluId("");
    setId("");
    setIMDbId("");
    setName("");
};
const handleAdd = (addHomeVideoReview) => (ev) => {
    ev.preventDefault();
    addHomeVideoReview();
};
const handleUpdate = ({ IMDbId, avForumsId, avNirvanaId, avsForumId, bluRayAuthorityId, bluRayId, digitalBitsId, doBluId, hidefDigestId, highDefDiscNewsId, homeTheaterForumId, theaterByteId, id, setPreview, whySoBluId }) => (ev) => {
    ev.preventDefault();
    setPreview({ message: `Loading Home Video Review...` });
    axios
        .put(`${HOSTNAME}:${PORT}/mightychroma/${id}`, {
        IMDbId: IMDbId || undefined,
        avForumsId: avForumsId || undefined,
        avNirvanaId: avNirvanaId || undefined,
        avsForumId: avsForumId || undefined,
        bluRayAuthorityId: bluRayAuthorityId || undefined,
        bluRayId: bluRayId || undefined,
        digitalBitsId: digitalBitsId || undefined,
        doBluId: doBluId || undefined,
        hidefDigestId: hidefDigestId || undefined,
        highDefDiscNewsId: highDefDiscNewsId || undefined,
        homeTheaterForumId: homeTheaterForumId || undefined,
        theaterByteId: theaterByteId || undefined,
        whySoBluId: whySoBluId || undefined
    })
        .then(({ data }) => {
        setPreview(data);
    });
};
const useInputs = (props) => {
    const [IMDbId, setIMDbId] = useState("");
    const [id, setId] = useState("");
    const [addHomeVideoReview, { data, loading }] = useMutation(ADD_HOME_VIDEO_REVIEW, {
        variables: {
            homeVideoReview: {
                IMDbId,
                avForumsId: props.avForumsId || undefined,
                avNirvanaId: props.avNirvanaId || undefined,
                avsForumId: props.avsForumId || undefined,
                bluRayAuthorityId: props.bluRayAuthorityId || undefined,
                bluRayId: props.bluRayId || undefined,
                digitalBitsId: props.digitalBitsId || undefined,
                doBluId: props.doBluId || undefined,
                hidefDigestId: props.hidefDigestId || undefined,
                highDefDiscNewsId: props.highDefDiscNewsId || undefined,
                homeTheaterForumId: props.homeTheaterForumId || undefined,
                isAddHomeVideo: true,
                isBluRay: true,
                isPublished: false,
                isUHD: props.isUHD,
                name: props.name,
                theaterByteId: props.theaterByteId || undefined,
                whySoBluId: props.whySoBluId || undefined
            }
        }
    });
    useEffect(() => {
        if (loading) {
            props.setPreview({ message: `Loading Mighty Chroma...` });
        }
        if (data) {
            props.setPreview(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, loading]);
    const onToggleIsUHD = () => {
        props.toggleIsUHD();
    };
    return {
        ...props,
        IMDbId,
        id,
        loading,
        onAdd: handleAdd(addHomeVideoReview),
        onChangeId: handleChangeId,
        onClear: handleClear({ ...props, setId, setIMDbId }),
        onToggleIsUHD,
        onUpdate: handleUpdate({ ...props, IMDbId, id }),
        setId,
        setIMDbId
    };
};
export default prepareComponent(useInputs)(HomeVideoReview);
